import React, { useContext, useEffect } from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { isEmpty, stringToBoolean } from 'deep-cuts';
import qs from 'qs';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import { LinkContainer } from 'react-router-bootstrap';
import { loadQueryParams } from '../redux/modules/queryParams';
import { sendStatements } from '../redux/modules/statements';
import * as storage from '../utils/storage';
import { downloadBankCsv } from '../utils/download';
import { AuthContext } from '../components/Auth';

const getQuery = () => qs.parse(window.location.search.replace(/^\?/gi, '')) || {};

const isAutoLogin = () => {
  const query = getQuery();
  return stringToBoolean(query.autoLogin);
};

const isTokenLogin = () => {
  const query = getQuery();
  return query.token && query.email && query.dealerId ? query : {};
};

export function Home(props) {
  const { user, isLoading, queryParamsLoaded, loadQueryParams, router, sendStatements } = props;
  const { login, tokenParams } = useContext(AuthContext);

  const list = process.env.REACT_APP_STATEMENTS_FEATURE_ALLOW_LIST;
  const individualStatementsAllowList = !_.isNil(list) ? list.split(',') : [];

  useEffect(() => {
    const { token, email, dealerId } = isTokenLogin();
    // NOTE - Unfortunately, all three are required for an application token login.
    if (!!token && !!email && !!dealerId) {
      login(token, email, dealerId);
    } else if (isAutoLogin() && !user) {
      login();
    }
  }, []);

  useEffect(() => {
    // Check for an external payment query
    if (user) {
      const paymentQuery = storage.get('paymentQuery');
      if (!_.isEmpty(paymentQuery) && !queryParamsLoaded) {
        loadQueryParams();
        router.push('/payment');
      }
    }
  }, [user, queryParamsLoaded, loadQueryParams, router]);

  if (isLoading) {
    return <ProgressBar now={100} active={true} />;
  }

  if (!user) {
    return (
      <div>
        <Helmet title="Payment Gateway" />

        <Grid>
          <Row>
            <Col md={6} xs={12} mdOffset={3}>
              <Button onClick={login} bsStyle="primary" bsSize="large" block>
                Login
              </Button>
              <LinkContainer to="/guestPayment">
                <Button bsStyle="default" bsSize="large" block>
                  Guest Payment
                </Button>
              </LinkContainer>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }

  const prcoAdmin = _.get(user, 'dealerRel.prcoAdmin');
  const onClickStatements = () =>
    window.open(
      [
        process.env.REACT_APP_STATEMENTS_URL,
        !isEmpty(tokenParams) ? qs.stringify(tokenParams) : undefined,
      ]
        .filter((v) => !!v)
        .join('?'),
      '_blank',
    );
  return (
    <div>
      <Helmet title="Home" />

      <Grid>
        {individualStatementsAllowList.includes(user.email) ? (
          <Row>
            <Col md={4} xs={6} mdOffset={2}>
              <Button
                bsStyle="primary"
                bsSize="large"
                block
                className="home-container-link-container"
                onClick={onClickStatements}
              >
                PRco Statements
              </Button>
            </Col>
            <Col md={4} xs={6}>
              <Button
                onClick={sendStatements}
                bsSize="large"
                block
                className="home-container-link-container"
              >
                Email Statements
              </Button>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col md={8} xs={12} mdOffset={2}>
              <Button
                bsStyle="primary"
                bsSize="large"
                block
                className="home-container-link-container"
                onClick={onClickStatements}
              >
                PRco Statements
              </Button>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={4} xs={12} mdOffset={2}>
            <LinkContainer to="/payment">
              <Button
                bsStyle="primary"
                bsSize="large"
                block
                className="home-container-link-container"
              >
                Make Payment
              </Button>
            </LinkContainer>
          </Col>
          <Col md={4} xs={12}>
            <LinkContainer to="/saveAccount">
              <Button
                bsStyle="default"
                bsSize="large"
                block
                className="home-container-link-container"
              >
                Save Account
              </Button>
            </LinkContainer>
          </Col>
        </Row>
        <Row>
          <Col md={8} xs={12} mdOffset={2}>
            <LinkContainer to="/payments">
              <Button
                bsStyle="primary"
                bsSize="large"
                block
                className="home-container-link-container"
              >
                Manage Payments
              </Button>
            </LinkContainer>
          </Col>
        </Row>
        <Row>
          <Col md={8} xs={12} mdOffset={2}>
            <LinkContainer to="/profile">
              <Button
                bsStyle="default"
                bsSize="large"
                block
                className="home-container-link-container"
              >
                Manage My Profile
              </Button>
            </LinkContainer>
          </Col>
        </Row>
        {prcoAdmin && (
          <Row>
            <Col md={8} xs={12} mdOffset={2}>
              <LinkContainer to="/admin/users">
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  block
                  className="home-container-link-container"
                >
                  ADMIN: Manage Users
                </Button>
              </LinkContainer>
            </Col>
          </Row>
        )}

        {prcoAdmin && (
          <Row>
            <Col md={8} xs={12} mdOffset={2}>
              <LinkContainer to="/admin/upload-bank-csv">
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  block
                  className="home-container-link-container"
                >
                  ADMIN: Upload bank CSV
                </Button>
              </LinkContainer>
            </Col>
          </Row>
        )}

        {prcoAdmin && (
          <Row>
            <Col md={8} xs={12} mdOffset={2}>
              <Button
                bsStyle="primary"
                bsSize="large"
                block
                className="home-container-link-container"
                onClick={() => downloadBankCsv()}
              >
                ADMIN: Download bank CSV
              </Button>
            </Col>
          </Row>
        )}

        {prcoAdmin && stringToBoolean(process.env.REACT_APP_CSV_UPLOADING_FEATURE_FLAG) && (
          <Row>
            <Col md={8} xs={12} mdOffset={2}>
              <LinkContainer to="admin/upload-address-csv">
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  block
                  className="home-container-link-container"
                >
                  ADMIN: Upload addresses file
                </Button>
              </LinkContainer>
            </Col>
          </Row>
        )}

        {prcoAdmin && (
          <Row>
            <Col md={8} xs={12} mdOffset={2}>
              <LinkContainer to="/admin/cache">
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  block
                  className="home-container-link-container"
                >
                  ADMIN: Cache
                </Button>
              </LinkContainer>
            </Col>
          </Row>
        )}
      </Grid>
    </div>
  );
}

export default connect(
  (state) => ({
    user: state.auth.user,
    queryParamsLoaded: state.queryParams.loaded,
    isLoading: state.auth.isLoading,
  }),
  {
    loadQueryParams,
    sendStatements,
  },
)(Home);
